import React__default, { memo } from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-701df069.js';

/* eslint-disable react/no-array-index-key */
const BORDER_WIDTH = '1px';
const displayAllMixin = /*#__PURE__*/css(["width:", ";:first-child{width:", ";}", ""], ({
  theme
}) => `calc(${theme.tree.arrowButtonDisplayAllSpacerWidth} - ${BORDER_WIDTH} + ${theme.tree.nodeHalfWidth})`, ({
  theme
}) => `calc(${theme.tree.arrowButtonDisplayAllTreeNodeSpacerWidth} - ${BORDER_WIDTH} + ${theme.tree.nodeHalfWidth})`, isMobile(css(["width:", ";:first-child{width:", ";}"], ({
  theme
}) => `calc(${theme.tree.mobile.arrowButtonDisplayAllSpacerWidth} - ${BORDER_WIDTH} + ${theme.tree.nodeHalfWidth})`, ({
  theme
}) => `calc(${theme.tree.mobile.arrowButtonDisplayAllTreeNodeSpacerWidth} - ${BORDER_WIDTH} + ${theme.tree.nodeHalfWidth})`)));
const Spacer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30051113__sc-1sd4q0f-0"
})(["border-inline-end:", " solid ", ";flex:0 0 auto;width:", ";", " ", ""], BORDER_WIDTH, ({
  theme
}) => theme.palette.gray[100], ({
  theme
}) => `calc(${theme.tree.arrowButtonWidth} - ${BORDER_WIDTH} + ${theme.tree.nodeHalfWidth})`, isMobile(css(["width:", ";"], ({
  theme
}) => `calc(${theme.tree.mobile.arrowButtonWidth} - ${BORDER_WIDTH} + ${theme.tree.nodeHalfWidth})`)), ({
  $displayAll
}) => $displayAll && displayAllMixin);
const DepthSpacer = ({
  depth,
  displayAll
}) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, new Array(depth).fill(0).map((_unused, index) => /*#__PURE__*/React__default.createElement(Spacer, {
  key: index,
  $displayAll: displayAll
})));
DepthSpacer.defaultProps = {
  displayAll: false
};
var DepthSpacer$1 = /*#__PURE__*/memo(DepthSpacer);

export { DepthSpacer$1 as D };
//# sourceMappingURL=DepthSpacer-ffdea263.js.map
